import Field from "../../shared/components/forms/field"
import React from "react"

export const COUNTRY_OF_RESIDENCE = 29
export const LANGUAGE = 85
export const STATE_OF_RESIDENCE = 140
export const FIRST_NAME = 158
export const LAST_NAME = 159
export const ADDRESS_1 = 160
export const ADDRESS_2 = 161
export const CITY = 162
export const ZIP_CODE = 163
export const LICENSED_COUNTRY = 40

export const SLN = 164

export const NPI = 75

export const TEXT_INPUT = 1
export const PICK_ONE_LIST = 3
export const UNIQUE_SECTION = "2"
export const isText = (inputType) => {
    return inputType == TEXT_INPUT
}

export const isPickOne = (inputType) => {
    return inputType == PICK_ONE_LIST
}

export const isPickMany = (inputType) => {
    return inputType == 4
}

export const isInteger = (inputType) => {
    return inputType == 5
}


export const clearDropdownCheckboxes = (array) => {
    return array.map((x) => {
        return { ...x, checked: false }
    })
}

export const mapBySection = (attributes, nonAttributeFields, previousAttributes = {}) => {
    let result = {}
    attributes.forEach(attribute => {
        if (attribute.attributeSequences && attribute.attributeSequences.length > 0) {
            const sequence = attribute.attributeSequences[0]
            if (sequence.section != 1) {
                if (attribute.id != LICENSED_COUNTRY) {
                    setDefaultValue(previousAttributes, sequence, attribute)
                }
                result[sequence.section] = result[sequence.section] ? [...result[sequence.section], attribute] : [attribute]
            }
        }
    })
    nonAttributeFields.forEach(nonAttr => {
        if (previousAttributes && previousAttributes[nonAttr.section]) {
            let previousAttribute = previousAttributes[nonAttr.section].find(x => x.id == nonAttr.id)
            if (previousAttribute && previousAttribute.value) {
                nonAttr.defaultValue = isPickOne(nonAttr.inputTypeId) ?
                    previousAttribute.value[0] : previousAttribute.value
            }
        }
        result[nonAttr.section] = result[nonAttr.section] ? [...result[nonAttr.section], nonAttr] : [nonAttr]
    })
    return result
}

export const buildMultipleOptions = (choices) => {
    return choices.map((element) => ({
        value: element.value, label: <Field
            type="checkbox"
            label={element.label}
            checked={element.checked}
            disabled={true}
        />,
        originalLabel: element.label,
        rollup: element.rollup,
    }))
}

const setDefaultValue = (previousAttributes, sequence, attribute) => {
    if (previousAttributes && previousAttributes[sequence.section]) {
        let previousAttribute = previousAttributes[sequence.section].find(x => x.id == attribute.id)
        if (previousAttribute && previousAttribute.value) {
            if (isPickOne(attribute.inputTypeId)) {
                attribute.defaultValue = previousAttribute.value.length > 0 ?
                    previousAttribute.value[0] : previousAttribute.value
            } else {
                attribute.defaultValue = previousAttribute.value
            }
        }
    }
}

export const buildUniqueAttributes = (attributes) => {
    let result =[]
    attributes.forEach(attribute => {
        if (attribute.attributeSequences && attribute.attributeSequences.length > 0) {
            const sequence = attribute.attributeSequences[0]
            if(sequence.section=== parseInt(UNIQUE_SECTION,10) && attribute.isUnique){
                  attribute.required ? attribute.valid = false : attribute.valid = true
                    result.push(attribute)
            }
        }
    })
    return result
}